<template>
  <div class="CommuneAutocomplete">
    <CommuneSearch
      v-model="geoDataModel"
      :disabled="disabled"
      chrome-tone="onLight"
      shell-class="relative flex h-8 w-full cursor-default flex-wrap items-center gap-1.5 overflow-hidden rounded-md border border-gray-300 bg-white text-left transition-colors duration-200 focus-within:border-main focus-within:outline-none focus-within:ring-1 focus-within:ring-main"
      input-class="min-w-[50px] flex-1 border-none bg-transparent py-1 pl-2 pr-10 text-sm leading-5 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-0"
      options-class="z-50"
      :placeholder-override="placeholder"
      :no-results-message="noDataText"
      @commune-selected="emit('communeSelected', $event)"
    >
      <template #prependInner>
        <div class="flex items-center pl-2 text-gray-500">
          <Icon icon="mdi:map-marker" color="main-blue" class="opacity-100" />
        </div>
      </template>
      <template #appendInner="{ isLoading }">
        <Transition name="CommuneAutocomplete__fade">
          <ProgressCircular
            v-if="isLoading"
            color="#888"
            :width="2"
            :size="20"
            indeterminate
          />
        </Transition>
      </template>
    </CommuneSearch>
  </div>
</template>

<script setup lang="ts">
import CommuneSearch from '@/components/forms/CommuneSearch.vue'
import type { CommuneApiResponse } from '@/services/commune/CommuneService'
import type { GeoData } from '@/models/interfaces/geo/GeoData'
import Icon from '@/components/ui/Icon.vue'
import ProgressCircular from '@/components/ui/ProgressCircular.vue'

defineOptions({
  name: 'CommuneAutocomplete',
})

withDefaults(
  defineProps<{
    /** Laissé vide, CommuneSearch applique son propre libellé, lui traduit. */
    placeholder?: string
    noDataText?: string
    disabled?: boolean
  }>(),
  {
    placeholder: undefined,
    noDataText: undefined,
    disabled: false,
  },
)

const geoDataModel = defineModel<GeoData | null>({ default: null })

const emit = defineEmits<{
  communeSelected: [commune: CommuneApiResponse]
}>()
</script>

<style scoped lang="scss">
.CommuneAutocomplete__fade-enter-active,
.CommuneAutocomplete__fade-leave-active {
  transition: opacity 0.15s ease;
}

.CommuneAutocomplete__fade-enter-from,
.CommuneAutocomplete__fade-leave-to {
  opacity: 0;
}
</style>
